export const paymentDetailsSelector = state => state.application.paymentDetails;
